import Typography from '@mui/material/Typography';

const TableTotal: React.FC<{
  pagetotal: number;
}> = ({ pagetotal }: any) => {
  return (
    <Typography component={'div'}>
      {pagetotal > 0 && (
        <Typography component={'div'} className={'show-text mt-24'}>
          Total No. of Records: {pagetotal}
        </Typography>
      )}
    </Typography>
  );
};
export default TableTotal;
